/**
 * Copyright © Vaimo Group. All rights reserved.
 * See LICENSE_VAIMO.txt for license details.
 */

import $ from 'jquery';

const BUTTON_TRIGGERS = 'button.action, a.action, a.view-product, .authorization-link a';
const SKIP_BUTTON_CLASSES = ['towishlist', 'search', 'subscribe'];

export default function () {
    $(document.body).on('click.btnActionAnimation', BUTTON_TRIGGERS, event => {
        var btn = event.currentTarget,
            $btn = $(btn),
            circle = document.createElement('div'),
            dimensions = Math.max(btn.clientWidth, btn.clientHeight),
            rect = btn.getBoundingClientRect(),
            skipMatch = false;

        SKIP_BUTTON_CLASSES.forEach(className => {
            if (btn.classList.contains(className)) {
                skipMatch = true;
            }
        });

        if (skipMatch) {
            return;
        }

        $btn.find('.ripple').remove();
        circle.style.width = circle.style.height = dimensions + 'px';
        circle.style.left = event.clientX - rect.left - dimensions / 2 + 'px';
        circle.style.top = event.clientY - rect.top - dimensions / 2 + 'px';
        $btn.append(circle);
        setTimeout(circle.classList.add('ripple'));
    });
}
